import React from 'react'
import Navbar from './Navbar'
import foodMenu from '../components/foodie'
import Footer from './Footer'

function Card({ heading, description, src }){
  return (
    <div div className='menu-main'>
      <div className='card-menu'>
        <h3>{heading}</h3>
        <p>{description}</p>
      </div>
      <div>
        <img src={src} alt={heading} />
      </div>
    </div>
  )

}

function Food() {

    return (
    <>
      <Navbar />
      <div className='food-main'>
        
          {foodMenu.map((item)=>{
          return <Card key={item.id} heading={item.name} description={item.description} src={item.src} />
          })}
        
      </div>
      <Footer />
    </>

    )
  }

export default Food